export { default as component } from "../../../../src/routes/[prefix]/(feature)/order/+page.svelte";